
const vAdminMenu = () => {
    const toggle = document.querySelector('.vjs-menu-toggle');
    const mqLarge = window.matchMedia('(min-width: 1200px)');

    if ( !toggle ) {
        return false;
    }

    const { body } = document;
    const menuMain = document.querySelector('.v-menu-main');
    const menuSecondary = document.querySelector('.v-menu-secondary');
    const menuState = window.localStorage.getItem('menu');

    if ( menuState === 'close' ) {
        closeMenu();
    }

    const toggleMenu = () => {

        if ( body.classList.contains('vjs-menu-closed') ) {
            openMenu();
        } else {
            closeMenu();
        }
    }

    function openMenu() {
        body.classList.remove('vjs-menu-closed');
        menuSecondary.classList.remove('close');
        window.localStorage.setItem('menu', 'open');


        if ( mqLarge.matches ) {
            menuMain.classList.remove('close');
            setTimeout(() => {
                // update main menu to text (instead of icons)
                menuMain.querySelectorAll('.v-menu-main__link-icon').forEach(el => {
                    el.classList.remove('show');
                    el.nextElementSibling.classList.remove('hide');
                });
            }, 10)
        }
    }

    function closeMenu() {
        body.classList.add('vjs-menu-closed');
        menuSecondary.classList.add('close');
        menuMain.classList.add('close');
        window.localStorage.setItem('menu', 'close');

        // update main menu to icons (instead of text)
        menuMain.querySelectorAll('.v-menu-main__link-icon').forEach(el => {
            el.classList.add('show');
            el.nextElementSibling.classList.add('hide');
        });
    }

    toggle.addEventListener('click', toggleMenu);
    mqLarge.addEventListener('change', () => {
        if ( mqLarge.matches ) {
            openMenu();
        } else {
            closeMenu();
        }
    });

}

export default vAdminMenu;
